var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chart-bar-stacked',{ref:"barChart",attrs:{"width":400,"height":170,"chart-data":_vm.chartData,"options":_vm.options}})}
var staticRenderFns = []

export { render, staticRenderFns }